export const SKIP_APPROVE = "SKIP_APPROVE";
export const SKIP_REJECT = "SKIP_REJECT";
export const SKIP_BID = "SKIP_BID";
export const SKIP_NOBID = "SKIP_NOBID";
export const SKIP_FLIP = "SKIP_FLIP";

const SKIP_OPTION_VALUES = [SKIP_APPROVE, SKIP_REJECT, SKIP_BID, SKIP_NOBID, SKIP_FLIP] as const;

export type SkipOptionValue = (typeof SKIP_OPTION_VALUES)[number];

export function isSkipOption(value: string | undefined | null): boolean {
  return value != null && (SKIP_OPTION_VALUES as readonly string[]).includes(value);
}

export function prefixSkipComment(
  comment: string,
  organizationName: string | undefined,
  t: (_key: string, _options?: { organizationName: string }) => string
): string {
  const prefix = organizationName
    ? t("chatinputbar.skipprefix", { organizationName })
    : t("chatinputbar.skipprefixgeneric");
  const trimmed = comment.trim();
  return trimmed ? `${prefix} ${trimmed}` : prefix;
}

export function getAwaitingOrganizationName(
  participants: { id: number; organizationName: string }[] | undefined,
  awaitingOrganizationId: number | null | undefined
): string | undefined {
  if (awaitingOrganizationId == null) {
    return undefined;
  }
  const organizationName = participants?.find((participant) => participant.id === awaitingOrganizationId)?.organizationName;
  return organizationName || undefined;
}
